import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import Header from '../components/Header';
import axios from 'axios';

const ImageUpload = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [formStatus, setFormStatus] = useState('Send');
    const onSubmit = async (e) => {
        e.preventDefault();
        setFormStatus("Submitting...");
        const { image } = e.target.elements;

        const imgForm = new FormData();
        imgForm.append("image", image.files[0]);

        axios
            .post(`${apiUrl}/bank/upload/`, imgForm, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                console.log(response);
                //setSponId(response.data.request_id)
                alert("Submission Successful. Thank you.")
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error)
                }
                console.log(error)
                alert("Submission failed, please try again");
            })
        setFormStatus("Send")
    }

    useEffect(() => {
        console.log(formStatus)
    }, [formStatus])

    return (
        <PageContainer>
            <Header />
            <PageContent>
                <Title>Fundraise & Recycle</Title>
                <Subtitle>Image Upload Tool</Subtitle>
                <Form onSubmit={onSubmit} className="sponsor-form" noValidate>
                    <div className="form-field-container">
                        <label className="form-label" htmlFor="image">Advert Image</label>
                        <input className="form-control" name="image_url" type="file" id="image" />
                    </div>
                    <button className="btn btn-danger" type="submit">
                        {formStatus}
                    </button>
                </Form>
            </PageContent>
        </PageContainer>
    )
}

export default ImageUpload;

const PageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const PageContent = styled.div`
    max-width: 1296px;
    width: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`

const Title = styled.h1`
    font-size: 48px;
    font-weight: normal;
    padding-left: 18px;
`

const Subtitle = styled.h2`
    text-align: center;
    padding-left: 18px;
`

const Form = styled.form`
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 470px;
    width: 100%;
    padding: 24px;
    
    .form-field-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        margin-top: 24px;
    }

    input {
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
    }

    #adPhoto {
        padding: 0;
    }

    label {
        margin-bottom: 8px;
        font-size: 18px;
        box-sizing: border-box;
    }

    button {
        border: 0;
        padding: 8px 24px;
        font-size: 18px;
        background: #AF3D58;
        color: white;
    }
    
    .form-field-container.checkbox {
        flex-direction: row;
        justify-content: flex-start;
    }

    .form-field-container.checkbox label {
        order: 2;
    }

    .form-field-container.checkbox input {
        order: 1;
    }

    #acceptTick,
    #mailTick,
    #hasVideo {
        width: auto;
    }

    .radio-option-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        margin: 4px 0;
    }

    .radio-option-container input.radio {
        width: auto;
        margin-right: 10px;
    }

    .radio-option-container label.radio {
        margin: 0;
        color: black;
        font-size: 14px;
    }

    #adlength {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }
`